// Saikrishna 27/10/2022 3075234474 Scheduling functionality --> ,Reccurence Pattern- Yearly(newly added total component)
// Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
// Saikrishna 28/10/2022 3075234474 minor bugfix
// akhila 03/11/2022 3075234474 get api integration and data prepopulation
// Raghu 11/09/2022 3075234474 Helper text and UI alignment fixes
// akhila 09/11/2022 3075234474 Added validation
// akhila 10/11/2022 3075234474 comment out the error's in textfield
// akhila  11/11/2022 3075234474 fixed validations issues
// Prakash  11/11/2022 3075234474 fixed validations Alignments issues.
// akhila 11/11/2022 3075234474 fixed form reset and validation issues.
// akhila 11/11/2022 3075234474 added new UI Fields for Reports
// Dilip 12/05/2022  3075234474 Removed unecesarry console.log statements
// Ashraf 12/28/2022 3075234474 renamed reoccurance label
// Prakash 07/04/2023 3075234474 fixed radio button color
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import {FormHelperText} from '@mui/material';
import React from 'react';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import reusableInputStyles from '../../../../../components/InputStyles';

const YearlySchedule = ({values, setFieldValue, handleChange, touched, errors, handleBlur, MonthNameOptions, WeekNoOptions, WeekDayNameOptions}) => {
  const classes = reusableInputStyles();
  return (
    <>
      <div className={classes.globalFieldTexts}>
        <FormControl component="fieldset" className={classes.checkBox}>
          <RadioGroup aria-label="yearly" name="yearly" value={values.yearly} onChange={handleChange}>
            <div className="d-flex align-items-center form-group">
              <FormLabel className={`mr-2 ${classes.formLabel}`}>Reoccur every</FormLabel>
              <div>
                <TextField
                  margin="dense"
                  variant="outlined"
                  className={classes.textComponent}
                  placeholder={``}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  name="yearlyYearFrequency"
                  value={values?.yearlyYearFrequency?.toUpperCase()}
                  onChange={handleChange}
                  error={Boolean(touched?.yearlyYearFrequency && errors?.yearlyYearFrequency)}
                  onBlur={handleBlur}
                />
                <FormHelperText>
                  {touched.yearlyYearFrequency && errors.yearlyYearFrequency}
                </FormHelperText>
              </div>
              <FormLabel className={`mx-2 ${classes.formLabel}`}>year(s)</FormLabel>
            </div>
            <div className="d-flex align-items-center form-group">
              <FormControlLabel value="yearlyOn" control={<Radio />} label="On: " onChange={(e) => {
                handleChange(e);
                setFieldValue('yearlyWeekNo', '');
                setFieldValue('yearlyWeekDayName', '');
                setFieldValue('yearlyOnTheMonthName', '');
              }}/>
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  name="yearlyOnMonthName"
                  size="small"
                  options={MonthNameOptions}
                  // fullWidth
                  // className="select-gender"
                  className={`ml-4 mx-2`}
                  label="Week Day"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.yearlyOnMonthName || 'none'}
                  disabled={values.yearly !== 'yearlyOn'}
                  onBlur={handleBlur}
                  touched={touched.yearlyOnMonthName}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('yearlyOnMonthName', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // error={Boolean(touched.yearlyOnMonthName && errors.yearlyOnMonthName)}
                      // required
                      // label="Week Day"
                      name="yearlyOnMonthName"
                      variant="standard"
                      margin="dense"
                      placeholder="Select month"
                    />
                  )}
                />
                <FormHelperText style={{paddingLeft: '20px'}}>
                  {touched.yearlyOnMonthName && errors.yearlyOnMonthName}
                </FormHelperText>
              </div>
              <div>
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder={``}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="yearlyOnDate"
                  disabled={values.yearly !== 'yearlyOn'}
                  value={values?.yearlyOnDate?.toUpperCase()}
                  onChange={handleChange}
                  // error={Boolean(touched?.yearlyOnDate && errors?.yearlyOnDate)}
                  onBlur={handleBlur}
                  className={`${classes.textComponent}`}
                />
                <FormHelperText >
                  {touched.yearlyOnDate && errors.yearlyOnDate}
                </FormHelperText>
              </div>
            </div>
            <div className="d-flex align-items-center form-group">
              <FormControlLabel value="yearlyOnThe" control={<Radio />} label="On the: " onChange={(e) => {
                handleChange(e);
                setFieldValue('yearlyOnMonthName', '');
                setFieldValue('yearlyOnDate', '');
              }}/>
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  name="yearlyWeekNo"
                  size="small"
                  options={WeekNoOptions}
                  // fullWidth
                  // className="select-gender"
                  // label="Type"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.yearlyWeekNo || 'none'}
                  onBlur={handleBlur}
                  disabled={values.yearly !== 'yearlyOnThe'}
                  touched={touched.yearlyWeekNo}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('yearlyWeekNo', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // error={Boolean(touched.yearlyWeekNo && errors.yearlyWeekNo)}
                      // required
                      // label="Yearly Week No"
                      name="yearlyWeekNo"
                      variant="standard"
                      margin="dense"
                      placeholder="Select yearly week no"
                    />
                  )}
                />
                <FormHelperText>
                  {touched.yearlyWeekNo && errors.yearlyWeekNo}
                </FormHelperText>
              </div>
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  name="yearlyWeekDayName"
                  size="small"
                  options={WeekDayNameOptions}
                  // fullWidth
                  // className="select-gender"
                  className={`mx-2`}
                  // label="Week Day"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.yearlyWeekDayName || 'none'}
                  onBlur={handleBlur}
                  disabled={values.yearly !== 'yearlyOnThe'}
                  touched={touched.yearlyWeekDayName}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('yearlyWeekDayName', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // error={Boolean(touched.yearlyWeekDayName && errors.yearlyWeekDayName)}
                      // required
                      // label="Week Day"
                      name="yearlyWeekDayName"
                      variant="standard"
                      margin="dense"
                      placeholder="Select yearly week Day"
                    />
                  )}
                />
                <FormHelperText>
                  {touched.yearlyWeekDayName && errors.yearlyWeekDayName}
                </FormHelperText>
              </div >

              <FormLabel className={`mr-2 ${classes.formLabel}`}>of</FormLabel>
              <div className={classes.autocompleteField}>
                <GuiAutoComplete
                  classes={{
                    option: classes.option,
                  }}
                  name="yearlyOnTheMonthName"
                  size="small"
                  options={MonthNameOptions}
                  // fullWidth
                  // className="select-gender"
                  // label="Week Day"
                  //   disabled={!isCopyRowData && windowNumber}
                  value={values.yearlyOnTheMonthName || 'none'}
                  disabled={values.yearly !== 'yearlyOnThe'}
                  onBlur={handleBlur}
                  touched={touched.yearlyOnTheMonthName}
                  getOptionLabel={(option) => (option?.value ? option.value : '')}
                  onChange={(event, value) => {
                    setFieldValue('yearlyOnTheMonthName', value);
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // error={Boolean(touched.yearlyOnTheMonthName && errors.yearlyOnTheMonthName)}
                      // required
                      // label="Week Day"
                      name="yearlyOnTheMonthName"
                      variant="standard"
                      margin="dense"
                      placeholder="Select month"
                    />
                  )}
                />
                <FormHelperText>
                  {touched.yearlyOnTheMonthName && errors.yearlyOnTheMonthName}
                </FormHelperText>
              </div>
            </div>
          </RadioGroup>
        </FormControl >
      </div >
    </>
  );
};

export default YearlySchedule;
